import Login1 from './1.png';
import Login2 from './2.png';
import Login3 from './3.png';
import Login4 from './4.png';
import Login5 from './5.png';
import Login6 from './6.png';
import LoginMail from './mail.png';

export { Login1, Login2, Login3, Login4, Login5, Login6, LoginMail };
